import { lazy, Suspense } from "react";

import { AccountingDenied } from "./AccountingDenied";
import { AccountingSkeleton } from "./AccountingSkeleton";
import { useAccountingAccess } from "./useAccountingAccess";

// Own chunk: only superadmins ever download the accounting code.
const AccountingApp = lazy(() =>
  import("./AccountingApp").then((m) => ({ default: m.AccountingApp })),
);

export const AccountingGate = () => {
  const access = useAccountingAccess();
  if (access === "denied") return <AccountingDenied />;
  if (access === "loading") return <AccountingSkeleton />;
  return (
    <Suspense fallback={<AccountingSkeleton />}>
      <AccountingApp />
    </Suspense>
  );
};
